import { Component, forwardRef } from '@angular/core';
import { Notification } from '../../../../core/models/notification.model';
import { buildViewModel } from '../../../../core/utils/viewmodel';
import { Observable } from 'rxjs';
import { NotificationsComponent, NotificationsManager } from '../../notifications.factory';
import { NotificationsService } from '../../services/notifications.service';

export interface NotificationsListViewModel {
    notifications$: Map<string, Notification>;
}

@Component({
    selector: 'ca-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss'],
    providers: [
        {
            provide: NotificationsComponent,
            useExisting: forwardRef(() => NotificationsListComponent),
        },
    ],
})
export class NotificationsListComponent implements NotificationsManager {
    vm$$ = buildViewModel<NotificationsListViewModel, Map<string, Notification>>({
        notifications$: this.notifications$,
    });
    constructor(private notificationsService: NotificationsService) {}

    get notifications$(): Observable<Map<string, Notification>> {
        return this.notificationsService.notifications$;
    }
}
